import './LoginError.component.scss';

import React from 'react';
import { FormattedMessage } from 'react-intl';

import { useAuth0 } from '../../../auth/auth';
import { TopBannerComponent } from '../../atoms/atoms.index';
import { NavbarComponent } from '../../organisms/organisms.index';

export function LoginErrorComponent(props: any) {
  const { logout } = useAuth0();

  return (
    <React.Fragment>
      <div className='page-container login-page'>
        <NavbarComponent
          showName={true}
          showLogout={true}
          showHelp={true}
          hideBack={true}
          noNavigateHome={true}
        />
        <TopBannerComponent />
        <div className='content-wrapper'>
          <section className='login-form-container pb-5'>
            <div className='d-flex flex-column'>
              <div className='login-content'>
                <h4 className='subtitle'>
                  <FormattedMessage id='pages.login.error' />
                </h4>
                <p className='mt-5'>
                  <span className='btn-link cursor-pointer' onClick={() => logout()}>
                    <FormattedMessage id='pages.login.login_with_another_account' />
                  </span>
                </p>
              </div>
            </div>
          </section>
        </div>
      </div>
    </React.Fragment>
  );
}
